import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import 'components/Modal/createModal.css';
import { AppButton } from 'app/components/shared/AppButton';

const style = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.default',
    border: '1px solid',
    boxShadow: 24,
    p: 2,
};

export default function ConfirmationModal({
    isOpen,
    handleCloseModal,
    title,
    handleDeleted,
}) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        handleCloseModal();
    };

    return (
        <>
            <div className="modalBackground">
                <div className="modalContainer2">
                    <div className="titleCloseBtn">
                        <button onClick={() => handleClose()}>X</button>
                    </div>
                    <div className="title">
                        <label
                            style={{
                                margin: 10,
                                marginLeft: '15px',
                                fontSize: '20px',
                            }}
                        >
                            {' '}
                            Are you sure you want to delete this item ?
                        </label>
                    </div>
                    <div className="footer" style={{ marginTop: '30px' }}>
                        <AppButton
                            variant={'outlined'}
                            style={{ fontSize: '14px' }}
                            action={handleDeleted}
                        >
                            Delete
                        </AppButton>

                        <AppButton
                            variant={'outlined'}
                            style={{ fontSize: '14px' }}
                            action={handleClose}
                        >
                            Cancel
                        </AppButton>
                    </div>
                </div>
            </div>
        </>
    );
}

